import React, { useContext, useMemo } from "react";
import SortSelect from "common/Select/SortSelect.tsx";
import { AccountsSort } from "@shared/features/portfolio/types.ts";
import { AccountsPageContext } from "features/portfolio/Accounts/AccountsPage.context.ts";
import { useBottomNavigator } from "utils/hooks/misc.tsx";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

import { LanguageNameSpaces } from "@shared/types";

const AccountsSortSelect = () => {
  const { baseShouldDisplay: isBottomNavigator } = useBottomNavigator();
  const { sortBy, setSortBy, sortDirection, setSortDirection } =
    useContext(AccountsPageContext)!;
  const { t, i18n } = useTypedTranslation(LanguageNameSpaces.PORTFOLIO);

  return useMemo(
    () => (
      <SortSelect
        setSortBy={setSortBy}
        sortBy={sortBy}
        sortDirection={sortDirection}
        setSortDirection={setSortDirection}
        sortValues={Object.values(AccountsSort)}
        rounded={true}
        isSingleFiltersChipsRow={isBottomNavigator}
        labelMapper={(value) => t(value)}
      />
    ),
    [sortBy, sortDirection, isBottomNavigator, i18n.language]
  );
};

export default AccountsSortSelect;
